








import pathToRegexp from 'path-to-regexp';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteRecord, Route } from 'vue-router';

@Component({
  name: 'Breadcrumb',
})
export default class extends Vue {
  private breadcrumbs: RouteRecord[] = [];

  @Watch('$route')
  private onRouteChange(route: Route) {
    // if you go to the redirect page, do not update the breadcrumbs
    if (route.path.startsWith('/redirect/')) {
      return;
    }
    this.getBreadcrumb();
  }

  private created() {
    this.getBreadcrumb();
  }

  private getBreadcrumb() {
    const matched = this.$route.matched.filter((item) => item.meta && item.meta.title);
    this.breadcrumbs = matched
      .map((item) => {
        const { title, breadcrumb } = item.meta;
        if (breadcrumb === false) {
          return undefined;
        }
        if (typeof title === 'function') {
          return {
            ...item,
            meta: {
              ...item.meta,
              title: title(this.$route),
            },
          };
        }
        return item;
      })
      .filter(Boolean) as RouteRecord[];
  }

  private pathCompile(path: string) {
    const { params } = this.$route;
    const toPath = pathToRegexp.compile(path);
    return toPath(params);
  }

  private handleLink(item: any) {
    const { redirect, path } = item;
    if (redirect) {
      this.$router.push(redirect);
      return;
    }
    this.$router.push(this.pathCompile(path));
  }
}
